/**
 * Offer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DowntimeDto } from './downtimeDto';
import { BankDetailsAddress } from './bankDetailsAddress';


export interface BankDetails { 
    modifiedFrom?: string;
    userChangeComment?: string;
    id?: string;
    bankId?: string;
    bankName?: string;
    shortBankName?: string;
    bankGateway?: BankDetails.BankGatewayEnum;
    bankUrl?: string;
    logoUrl?: string;
    identificationProcess?: BankDetails.IdentificationProcessEnum;
    postIdentPossible?: boolean;
    euriborCalculation?: BankDetails.EuriborCalculationEnum;
    nominalInterest?: number;
    effectiveInterest?: number;
    deferrableKSV?: boolean;
    reportDays?: number;
    bankPhoneNumber?: string;
    phoneBusinessHours?: string;
    address?: BankDetailsAddress;
    scheduledDowntimes?: Array<DowntimeDto>;
    availableInBcc?: boolean;
}
export namespace BankDetails {
    export type BankGatewayEnum = 'BAWAG' | 'ANADIBANK' | 'SANTANDER' | 'RAIFFEISEN' | 'BANKAUSTRIA' | 'OBERBANK' | 'DENZELBANK' | 'TARGOBANK' | 'TFBANK' | 'SWK' | 'NOVUMBANK' | 'SPARKASSEFELDKIRCHEN' | 'BANK99' | 'EASYBANK' | 'WSK' | 'CA_AUTOBANK' | 'TESTGATEWAY';
    export const BankGatewayEnum = {
        Bawag: 'BAWAG' as BankGatewayEnum,
        Anadibank: 'ANADIBANK' as BankGatewayEnum,
        Santander: 'SANTANDER' as BankGatewayEnum,
        Raiffeisen: 'RAIFFEISEN' as BankGatewayEnum,
        Bankaustria: 'BANKAUSTRIA' as BankGatewayEnum,
        Oberbank: 'OBERBANK' as BankGatewayEnum,
        Denzelbank: 'DENZELBANK' as BankGatewayEnum,
        Targobank: 'TARGOBANK' as BankGatewayEnum,
        Tfbank: 'TFBANK' as BankGatewayEnum,
        Swk: 'SWK' as BankGatewayEnum,
        Novumbank: 'NOVUMBANK' as BankGatewayEnum,
        Sparkassefeldkirchen: 'SPARKASSEFELDKIRCHEN' as BankGatewayEnum,
        Bank99: 'BANK99' as BankGatewayEnum,
        Easybank: 'EASYBANK' as BankGatewayEnum,
        Wsk: 'WSK' as BankGatewayEnum,
        CaAutobank: 'CA_AUTOBANK' as BankGatewayEnum,
        Testgateway: 'TESTGATEWAY' as BankGatewayEnum
    };
    export type IdentificationProcessEnum = 'EPS' | 'IDAUSTRIA' | 'IDNOW' | 'IDTRUST' | 'NONE' | 'SELFIDENT' | 'POS' | 'WEBID' | 'WEBID_VIDEO_ONLY' | 'EXTERNAL' | 'EXTERNAL_IDAUSTRIA' | 'EXTERNAL_SELFIDENT';
    export const IdentificationProcessEnum = {
        Eps: 'EPS' as IdentificationProcessEnum,
        Idaustria: 'IDAUSTRIA' as IdentificationProcessEnum,
        Idnow: 'IDNOW' as IdentificationProcessEnum,
        Idtrust: 'IDTRUST' as IdentificationProcessEnum,
        None: 'NONE' as IdentificationProcessEnum,
        Selfident: 'SELFIDENT' as IdentificationProcessEnum,
        Pos: 'POS' as IdentificationProcessEnum,
        Webid: 'WEBID' as IdentificationProcessEnum,
        WebidVideoOnly: 'WEBID_VIDEO_ONLY' as IdentificationProcessEnum,
        External: 'EXTERNAL' as IdentificationProcessEnum,
        ExternalIdaustria: 'EXTERNAL_IDAUSTRIA' as IdentificationProcessEnum,
        ExternalSelfident: 'EXTERNAL_SELFIDENT' as IdentificationProcessEnum
    };
    export type EuriborCalculationEnum = 'DEFAULT' | 'JANUARY03_JULY03' | 'DENZELBANK';
    export const EuriborCalculationEnum = {
        Default: 'DEFAULT' as EuriborCalculationEnum,
        January03July03: 'JANUARY03_JULY03' as EuriborCalculationEnum,
        Denzelbank: 'DENZELBANK' as EuriborCalculationEnum
    };
}


